/**
 * created by xcc
 * 新媒体矩阵榜单
 *
 */
import React, {Component} from 'react';
import {Button, Input, Select, Tabs, DatePicker, Table, Pagination, Icon, message} from "antd";
import moment from 'moment';
import Scrollbars from 'react-custom-scrollbars';
import "./newMediaMatrixCss.css";
import {connect} from "react-redux";
import {getList, getDeptAll, listExport, getData, listPdf} from "./newMediaMatrixListActions";
import TableTemplate from "../../components/TableTemplate/TableTemplate";
import {getInfoFromLocalStorage, setInfoToLocalStorage} from "../../../../actions";
import TabsTemplate from "../../components/TabsTemplate/TabsTemplate";
import {formatCount, newFormatCount, uuid} from "../../../../utils";

const {Option} = Select;
const {Search} = Input;
const {TabPane} = Tabs;
const {WeekPicker, MonthPicker, RangePicker} = DatePicker;

class NewMediaMatrixList extends Component {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            listType: '1',
            startTime: moment().startOf('days').add(-1, 'days'),//开始时间,
            endTime: moment().endOf('days').add(-1, 'days'),
            deptId: null,//所属部门
            searchText: '',//搜索的文字
            page: 1,//当前页数
            size: 10,//当前页数据条数,
            dataSource: [],//列表数据源
            total: 0,//总条数
            departAllList: [],//所有的部门
            grade: null,
            isOpen: false,
            navsList:[]
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        let params = getInfoFromLocalStorage("mediaMatrixNewList");
        if (params) {
            // 初始化完成后，将自定义榜单中的日期范围默认设置为上一个月整月范围的时间
            this.setState({
                startTime: params.startTime ? (params.listType === '5' ? moment().subtract(1, 'month').startOf('months') : moment(params.startTime)) : null,
                endTime: params.endTime ? (params.listType === '5' ? moment().subtract(1, 'month').endOf('months') : moment(params.endTime)) : null,
                listType: params.listType
            }, () => {
                this.getList({startTime:this.state.startTime.valueOf(),endTime:this.state.endTime.valueOf()})
            })
        } else {
            let data = {
                startTime: new Date(moment().startOf('days').add(-1, 'days')).getTime(),
                endTime: new Date(moment().startOf('days')).getTime()
            };
            this.getList(data);
        }
        this.getData();
        this.getDeptAll();
    }

    getData =() =>{
        getData({}, (data) => {
            if(data&&data.length){
                data.forEach(item=>{
                    item.key = item.gradeKey;
                    item.name = item.grade
                });
                this.state.navsList = this.state.navsList.concat(data)
            }
            this.setState({})
        })

    };

    getList(data) {
        let params = {
            page: this.state.page,
            size: this.state.size,
            startTime: data.startTime,
            endTime: data.endTime
        };
        if (this.state.deptId) {
            params.deptId = this.state.deptId
        }
        if (this.state.grade) {
            params.grade = this.state.grade
        }
        if (this.state.searchText) {
            params.keyword = encodeURIComponent(this.state.searchText)
        }
        getList(params, (data) => {
            let dataSource = [];
            let total = 0;
            if (data && data.data && data.data.length) {
                total = data.count;
                dataSource = data.data;
            }
            this.setState({
                dataSource,
                total
            })
        });
    }


    //获取所有部门
    getDeptAll() {
        getDeptAll((data) => {
            let departAllList = [];
            if (data &&  data.length) {
                departAllList = data.filter(item => item.id !== "0");
            }
            this.setState({
                departAllList
            })
        })
    }

    render() {
        return (
            <div style={{
                background: 'white',
                borderRadius: '5px',
                margin: '15px 0',
                // padding: '0 32px',
                maxHeight: 'calc(100vh - 100px)'
            }}>
                {this.renderScreen()}
                {this.renderList()}
            </div>
        )
    }

    renderList() {
        const columns = [
            {
                title: '排名',
                key: 'key',
                dataIndex: 'createTime',
                ellipsis: true,
                render: (text, record, index) => {
                    return (
                        <div title={(index + 1) + (this.state.page - 1) * (this.state.size)} style={{
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                        }}>
                            {(index + 1) + (this.state.page - 1) * (this.state.size)}
                        </div>
                    )
                }
            },
            {
                title: '账号名称',
                dataIndex: 'mediaName',
                key: 'mediaName',
                ellipsis: true,
            },
            {
                title: '所属部门',
                key: "mediaDeptName",
                dataIndex: 'mediaDeptName',
                ellipsis: true,

            },
            {
                title: '账号等级',
                dataIndex: 'grade',
                key: 'grade',
                width: this.state.navsList?.length ? 150 : 0,
                ellipsis: true,
                render: (text, record, index) => {
                    let data =  this.state.navsList&&this.state.navsList.length&&this.state.navsList.filter(item => item.key === text);
                   let newData = data?.[0]?.name?data[0].name:'';
                    return (
                        <div>{newData}</div>
                    )
                }
            },
            {
                title: '发文数',
                dataIndex: 'totalArticle',
                key: 'totalArticle',
                ellipsis: true,
                render: (text, record) => {
                    return (<div>{text ? formatCount(text) : 0}</div>)
                }
            },
            {
                title: '总阅读',
                dataIndex: 'totalReadCount',
                key: 'totalReadCount',
                ellipsis: true,
                render: (text, record) => {
                    return (<div>{text ? newFormatCount(text) : 0}</div>)
                }
            },
            {
                title: '平均阅读',
                dataIndex: 'avgReadCount',
                key: 'avgReadCount',
                ellipsis: true,
                render: (text, record) => {
                    return (<div>{text ? formatCount(text) : 0}</div>)
                }
            },
            {
                title: '最大阅读',
                dataIndex: 'maxReadCount',
                key: 'maxReadCount',
                ellipsis: true,
                render: (text, record) => {
                    return (<div>{text ? formatCount(text) : 0}</div>)
                }
            },
            {
                title: '总点赞',
                dataIndex: 'totalLikeCount',
                key: 'totalLikeCount',
                ellipsis: true,
                render: (text, record) => {
                    return (<div>{text ? formatCount(text) : 0}</div>)
                }
            },
            {
                title: '总在看',
                dataIndex: 'totalInsightCount',
                key: 'totalInsightCount',
                ellipsis: true,
                render: (text, record) => {
                    return (<div>{text ? formatCount(text) : 0}</div>)
                }
            },
            {
                title: '综合指数',
                dataIndex: 'index',
                key: 'index',
                ellipsis: true,
            },
        ];
        return (
            <div style={{padding: '0 32px',}}>
                <Scrollbars autoHide autoHeight autoHeightMax={"calc(100vh - 272px)"}>
                    <TableTemplate
                        columns={columns}
                        dataSource={this.state.dataSource}
                        pagination={false}
                        onResize={(offsetHeight) => {
                            if (this.tableHeaderHeight != offsetHeight) {
                                this.tableHeaderHeight = offsetHeight;
                                this.setState({});
                            }
                        }}/>
                </Scrollbars>
                {this.state.dataSource && this.state.dataSource.length > 0 && <div style={{padding: "10px", display: "flex", justifyContent: "flex-end",}}>
                    <Pagination
                        onChange={(page, pageSize) => {
                            this.paginationChange(page, pageSize)
                        }}//页码改变回调
                        onShowSizeChange={(page, pageSize) => {
                            this.paginationChange(page, pageSize)
                        }}//每页条数改变回调
                        defaultCurrent={1}
                        defaultPageSize={10}
                        total={this.state.total}
                        showTotal={total => `共${total}条`}
                        current={this.state.page}
                        pageSize={this.state.size}
                        showSizeChanger
                        showQuickJumper
                        hideOnSinglePage={false}
                    />
                </div>}
            </div>
        )
    }

    // tab切换时应该显示当前选中榜单的日期范围，不是显示当前时间的范围，比如今天是11月5日，榜单选择的是11月2日，那么切换时应该显示11月2日的榜单
    listTypeChange(key) {
        let data = {};
        let {startTime, endTime} =  getInfoFromLocalStorage("mediaMatrixNewList");
        // 如果session值为null，设置为当天时间
        if (key === "1") {
            this.state.startTime = moment(startTime).startOf('days');
            data = {
                startTime: moment(startTime).startOf('days').valueOf(),//开始时间
                endTime: moment(endTime).endOf('days').valueOf(),//结束时间
            }
        } else if (key === "2") {
            this.state.startTime = moment(startTime).startOf('week');
            data = {
                startTime: moment(startTime).startOf('weeks').valueOf(),//开始时间
                endTime: moment(endTime).endOf('weeks').valueOf(),//结束时间
            }
        } else if (key === "3") {
            this.state.startTime = moment(startTime).startOf('month');
            data = {
                startTime: moment(startTime).startOf('months').valueOf(),//开始时间
                endTime: moment(endTime).endOf('months').valueOf(),//结束时间
            }
        } else if (key === "4") {
            this.state.startTime = moment(startTime).startOf('year');
            data = {
                startTime: moment(startTime).startOf('years').valueOf(),//开始时间
                endTime: moment(endTime).endOf('years').valueOf(),//结束时间
            }
        } else if (key === "5") {
            this.state.startTime = moment().subtract(1,'month').startOf('months');
            this.state.endTime = moment().subtract(1,'month').endOf('months');
            data = {
                startTime: moment().subtract(1,'month').startOf('months').valueOf(),//开始时间
                endTime: moment().subtract(1,'month').endOf('months').valueOf(),//结束时间
            }
        }
        if(key !== '5') {
            setInfoToLocalStorage("NewMediaMatrixList", {
                ...data,
                listType: key,
            });
            this.props.showFun && this.props.showFun()
        }
        this.setState({}, () => {
            if (this.state.startTime) {
                this.getList(data);
            } else {
                this.setState({
                    dataSource: []
                })
            }
        })
    }
    CustomWeekPicker = () => {
        // 获取当前日期
        const currentDate = moment();

        // 获取当前年份和周数
        const currentYear = currentDate.year();
        const currentWeek = currentDate.week();

        // 定义默认的显示文本
        let placeholderText = 'Select week';

        // 根据不同的日期点进入组件，设置不同的显示文本
        if (currentDate.isSameOrBefore(moment('2022-12-31'))) {
            placeholderText = `${currentYear}年${currentWeek}周`;
        } else {
            placeholderText = '第一周';
        }
    }

    renderDateComponents() {
        if (this.state.listType === "1") {
            return (
                <DatePicker
                    format={"YYYY-MM-DD"}
                    value={this.state.startTime}
                    onChange={(date, dateString) => {
                        this.CustomWeekPicker(date, dateString);
                        if (!date) {
                            this.listTypeChange("1");
                            return;
                        }
                        let data = {
                            startTime: new Date(moment(date).startOf('days')).getTime(),
                            endTime: new Date(moment(date).startOf("days").add(1, 'days')).getTime()
                        }
                        this.getList(data)
                        this.setState({
                            startTime: date
                        })
                    }}
                />
            )
        } else if (this.state.listType === "2") {
            return (
                <WeekPicker
                    value={this.state.startTime}
                    onChange={(date) => {
                        if (!date) {
                            this.listTypeChange("2");
                            return;
                        }
                        let data = {
                            startTime: new Date(moment(date).week(moment(date).week()).startOf('week')).getTime(),
                            endTime: new Date(moment(date).week(moment(date).week()).endOf('week')).getTime()
                        }
                        this.getList(data)
                        this.setState({
                            startTime: date
                        })
                    }}
                />
            )
            //     冒泡排序

        } else if (this.state.listType === "3") {
            return (
                <MonthPicker
                    value={this.state.startTime}
                    onChange={(date) => {
                        if (!date) {
                            this.listTypeChange("3");
                            return;
                        }
                        let data = {
                            startTime: new Date(moment(date).month(moment(date).month()).startOf('month')).getTime(),
                            endTime: new Date(moment(date).month(moment(date).month()).endOf('month')).getTime()
                        }
                        this.getList(data)
                        this.setState({
                            startTime: date
                        })
                    }}
                />
            )
        } else if (this.state.listType === "4") {
            return (
                <DatePicker
                    value={this.state.startTime}
                    open={this.state.isOpen}
                    mode="year"
                    format="YYYY"
                    onOpenChange={(status) => {
                        if (status) {
                            this.setState({isOpen: true})
                        } else {
                            this.setState({isOpen: false})
                        }
                    }}
                    onPanelChange={(date) => {
                        if (!date) {
                            this.listTypeChange("4");
                            return;
                        }
                        let data = {
                            startTime: new Date(moment(date).year(moment(date).year()).startOf('year')).getTime(),
                            endTime: new Date(moment(date).year(moment(date).year()).endOf('year')).getTime()
                        }
                        this.getList(data)
                        this.setState({
                            startTime: date,
                            isOpen: false
                        })
                    }}
                    onChange={() => {
                        this.setState({
                            startTime: null
                        })
                    }}
                />
            )
        } else {
            return (
                <RangePicker value={[this.state.startTime, this.state.endTime]}
                             format={"YYYY-MM-DD"}
                             allowClear={false}
                             disabled={this.state.listType !== "5"}
                             disabledDate={this.disabledDate}
                             onChange={(dates, dateStrings) => {
                                 const [start, end] = dates;
                                 this.setState({
                                     startTime: start,
                                     endTime: end
                                 }, () => {
                                     const data = {
                                         startTime: start ? start.valueOf() : null,
                                         endTime: end ? end.valueOf() : null
                                     };
                                     this.getList(data);
                                 });
                             }}
                             onOk={() => {
                                 const data = {
                                     startTime: this.state.startTime ? this.state.startTime.valueOf() : null,
                                     endTime: this.state.endTime ? this.state.endTime.valueOf() : null
                                 };
                                 this.getList(data);
                             }}
                />
            )
        }
    }
    disabledDate = (current)=>{
        const today = moment();
        return current && current?.isAfter(today, 'day');
    };

    refreshList(type) {
        let data;
        let date = this.state.startTime;
        if (this.state.listType === "1") {
            data = {
                startTime: new Date(moment(date).startOf('days')).getTime(),
                endTime: new Date(moment(date).startOf("days").add(1, 'days')).getTime()
            }
        } else if (this.state.listType === "2") {
            data = {
                startTime: new Date(moment(date).week(moment(date).week()).startOf('week')).getTime(),
                endTime: new Date(moment(date).week(moment(date).week()).endOf('week')).getTime()
            }
        } else if (this.state.listType === "3") {
            data = {
                startTime: new Date(moment(date).month(moment(date).month()).startOf('month')).getTime(),
                endTime: new Date(moment(date).month(moment(date).month()).endOf('month')).getTime()
            }
        } else if (this.state.listType === "4") {
            data = {
                startTime: new Date(moment(date).year(moment(date).year()).startOf('year')).getTime(),
                endTime: new Date(moment(date).year(moment(date).year()).endOf('year')).getTime()
            }
        } else {
            data = {
                startTime: new Date(this.state.startTime).getTime(),
                endTime: new Date(this.state.endTime).getTime()
            }
        }
        if (type) {
            return data;
        }
        this.getList(data);
    }


    //渲染筛选条件
    renderScreen() {
        let {navsList} = this.state;
        return (
            <div className={'list_Tab'} style={{marginBottom: '15px'}}>
                <Tabs defaultActiveKey={this.state.listType} tabBarStyle={{padding: "0 32px"}} activeKey={this.state.listType}
                      onChange={(key) => {
                              this.state.listType=key;
                              this.state.page = 1;
                              this.state.size = 10;
                              this.state.deptId = null;
                              this.state.searchText = "";
                              this.state.grade = null;
                              this.setState({},()=>{
                                  this.listTypeChange(key);
                              });
                      }}>
                    <TabPane tab={"日榜"} key={'1'}/>
                    <TabPane tab={"周榜"} key={'2'}/>
                    <TabPane tab={"月榜"} key={'3'}/>
                    <TabPane tab={"年榜"} key={'4'}/>
                    <TabPane tab={"自定义榜单"} key={'5'}/>
                </Tabs>
                <div style={{float: 'left', paddingLeft: "32px"}}>
                    <div className={'newMediaMatrixListTitle'} style={{float: 'left'}}>自定义时间</div>
                    <div style={{float: 'left'}} className={"newMediaMatrixListContent"}>
                        {this.renderDateComponents()}
                    </div>
                </div>
                <div style={{float: 'left'}}>
                    <div style={{float: 'left', width: 250, paddingLeft: "20px"}} className={'newMediaMatrixListContent'}>
                        <Select
                            showSearch
                            allowClear
                            optionFilterProp="children"
                            placeholder={"所属部门"}
                            value={this.state.deptId || undefined}
                            style={{width: '100%'}}

                            onChange={(value) => {
                                this.state.deptId = value;
                                this.state.page = 1;
                                this.state.size = 10;
                                if (this.state.startTime) {
                                    this.refreshList()
                                } else {
                                    this.setState({
                                        dataSource: []
                                    })
                                }
                            }}>
                            {this.state.departAllList.map((item, i) => {
                                return (
                                    <Option key={i} value={item.id}>{item.name}</Option>
                                )
                            })
                            }
                        </Select></div>
                </div>
                {navsList && navsList.length > 0 && (
                    <div style={{ float: 'left' }}>
                        <div style={{ float: 'left', width: 180, paddingLeft: "20px" }} className={'newMediaMatrixListContent'}>
                            <Select allowClear placeholder={'账号等级'} value={this.state.grade || undefined} style={{ width: '100%' }} onChange={(value) => {
                                this.state.grade = value;
                                this.state.page = 1;
                                this.state.size = 10;
                                if (this.state.startTime) {
                                    this.refreshList()
                                } else {
                                    this.setState({
                                        dataSource: []
                                    })
                                }
                            }}>
                                {
                                    navsList.map((item, index) => {
                                        return <Option key={index} value={item.key}>{item.name}</Option>
                                    })
                                }
                            </Select>
                        </div>
                    </div>
                )}
                <div style={{float: 'left', marginLeft: 10}} className={'newMediaMatrixListTitle'}>
                    <Search
                        placeholder="请输入公众号名称"
                        size="default"
                        onChange={(e) => {
                            this.setState({
                                searchText: e.target.value
                            })
                        }}
                        value={this.state.searchText}
                        onSearch={value => {
                            this.state.page = 1;
                            this.state.size = 10;
                            this.state.searchText = value;
                            if (this.state.startTime) {
                                this.refreshList()
                            } else {
                                message.destroy();
                                message.warning('请设置自定义时间');
                                this.setState({
                                    dataSource: []
                                })
                            }
                        }}
                    />
                </div>
                <div style={{float: 'left'}} className={'newMediaMatrixListTitle'}>
                    <Button onClick={() => {
                        this.revert()
                    }}>重置</Button>
                </div>
                <div style={{float: 'right', marginRight: 32}} className={'newMediaMatrixListTitle'}>
                    <Button onClick={() => {
                        this.props.showFun && this.props.showFun()
                    }}><Icon type="rollback"/>返回</Button>
                </div>
                <div style={{float: 'right'}} className={'newMediaMatrixListTitle'}>
                    <Button onClick={() => {
                        this.exportExcel()
                    }}>导出Excel</Button>
                </div>
                <div style={{float: 'right'}} className={'newMediaMatrixListTitle'}>
                    <Button onClick={() => {
                        this.exportPdf()
                    }}>导出Pdf</Button>
                </div>
                <div style={{clear: 'both'}}/>
            </div>
        )
    }

    exportExcel() {
        let startTime = null;
        let endTime = null;
        let timeObj = this.refreshList("export");
        if (this.state.startTime) {
            startTime = timeObj.startTime;
            endTime = timeObj.endTime;
        }
        let params = {
            startTime: startTime,
            endTime: endTime
        }
        if (this.state.deptId) {
            params.deptId = this.state.deptId
        }
        if (this.state.grade) {
            params.grade = this.state.grade
        }
        if (this.state.searchText) {
            params.keyword = this.state.searchText
        }
        window.loading.show();
        listExport(params, (url) => {
            window.loading.hide();
            if (url) {
                let a = document.createElement("a");
                a.href = url;
                document.body.append(a); // 修复firefox中无法触发click
                a.click();
                document.body.removeChild(a);
                window.open(url, "_self");
            }
        })
    }

    exportPdf() {
        let startTime = null;
        let endTime = null;
        let timeObj = this.refreshList("export");
        if (this.state.startTime) {
            startTime = timeObj.startTime;
            endTime = timeObj.endTime;
        }
        let params = {
            startTime: startTime,
            endTime: endTime,
            type: this.state.listType
        }
        if (this.state.deptId) {
            params.deptId = this.state.deptId
        }
        if (this.state.grade) {
            params.grade = this.state.grade
        }
        if (this.state.searchText) {
            params.keyword = this.state.searchText
        }
        window.loading.show();
        listPdf(params, (url) => {
            window.loading.hide();
            if (url) {
                let a = document.createElement("a");
                a.href = url;
                document.body.append(a); // 修复firefox中无法触发click
                a.click();
                document.body.removeChild(a);
                window.open(url, "_self");
            }
        })
    }

    //点击重置按钮
    revert() {
       let data =  getInfoFromLocalStorage("mediaMatrixNewList")
        if(this.state.listType === "5") {
            data = {
                startTime: moment().subtract(1,'month').startOf('months').valueOf(),//开始时间
                endTime: moment().subtract(1,'month').endOf('months').valueOf(),//结束时间
            }
        }
        this.setState({
            startTime: data.startTime ? moment(data.startTime) : null,
            endTime: data.endTime ? moment(data.endTime) : null,
            deptId: null,//所属部门
            searchText: '',//搜索的文字
            page: 1,//当前页数
            size: 10,//当前页数据条数,
            grade: null
        }, () => {
           let data = {
                startTime: new Date(this.state.startTime).getTime(),
                endTime: new Date(this.state.endTime).getTime(),
            }
            this.getList(data);
        })
    }

    paginationChange(page, pageSize) {
        this.state.page = page;
        this.state.size = pageSize;
        this.refreshList()
    }
}

function mapStateToProps(state) {
    return {
        currentUser: state.systemReducer.currentUser,
    }
}

export default connect(mapStateToProps)(NewMediaMatrixList);